import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue";
const _hoisted_1 = { class: "container" };
const _hoisted_2 = { class: "oil-finder-panel" };
const _hoisted_3 = {
    key: 0,
    class: "oil-finder-panel__tabs"
};
const _hoisted_4 = { class: "vehicle-details-header__plate" };
const _hoisted_5 = { class: "oil-finder-panel__content" };
const _hoisted_6 = {
    key: 0,
    class: "oil-finder-panel__licence-plate-section"
};
const _hoisted_7 = { class: "oil-finder-panel__header" };
const _hoisted_8 = { class: "oil-finder-panel__logo" };
const _hoisted_9 = ["src"];
const _hoisted_10 = { class: "oil-finder-panel__number-plate-input" };
const _hoisted_11 = {
    key: 1,
    class: "oil-finder-panel__make-model-section"
};
const _hoisted_12 = {
    key: 2,
    class: "oil-finder-panel__alternative"
};
const _hoisted_13 = { class: "oil-finder-panel__tab--text__icon" };
const _hoisted_14 = ["src"];
import { onMounted, onUnmounted, ref } from 'vue';
import NumberPlateInput from './NumberPlateInput.vue';
import MakeModelSearch from './MakeModelSearch.vue';
import LicensePlateCard from './LicensePlateCard.vue';
import LicensePlateEditOverlay from './LicensePlateEditOverlay.vue';
import { useAssets } from '../../composables/useAssets';
import { useSearchTabs } from '../../composables/useSearchTabs';
import { useVehicleDetails } from '../../composables/useVehicleDetails';
export default /*@__PURE__*/ _defineComponent({
    __name: 'SearchTabPanels',
    emits: ["vehicleChanged"],
    setup(__props, { emit: __emit }) {
        const { assetUrl } = useAssets();
        const { activeTab, setActiveTab } = useSearchTabs();
        const { licencePlate } = useVehicleDetails();
        const emit = __emit;
        const editOverlay = ref(null);
        const editLicensePlate = () => {
            editOverlay.value?.open();
        };
        const handleVehicleSelected = (vehicle) => {
            if (vehicle.id) {
                emit('vehicleChanged', vehicle.id);
                editOverlay.value?.closeOverlay();
            }
        };
        const handleEscKey = (e) => {
            if (e.key === 'Escape') {
                editOverlay.value?.closeOverlay();
            }
        };
        onMounted(() => {
            window.addEventListener('keydown', handleEscKey);
        });
        onUnmounted(() => {
            window.removeEventListener('keydown', handleEscKey);
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        (_unref(activeTab) === 2)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                                _createElementVNode("div", _hoisted_4, [
                                    _createVNode(LicensePlateCard, {
                                        "licence-plate": _unref(licencePlate),
                                        onEdit: editLicensePlate
                                    }, null, 8, ["licence-plate"])
                                ])
                            ]))
                            : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_5, [
                            (_unref(activeTab) === 1)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                    _createElementVNode("div", _hoisted_7, [
                                        _createElementVNode("div", _hoisted_8, [
                                            _createElementVNode("img", {
                                                src: _unref(assetUrl)('/images/trade-site/drop.svg'),
                                                alt: ""
                                            }, null, 8, _hoisted_9)
                                        ]),
                                        _cache[1] || (_cache[1] = _createElementVNode("h1", { class: "oil-finder-panel__title" }, " Find the right oil for your vehicle ", -1))
                                    ]),
                                    _createElementVNode("div", _hoisted_10, [
                                        _createVNode(NumberPlateInput)
                                    ])
                                ]))
                                : _createCommentVNode("", true),
                            (_unref(activeTab) === 2)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                    _createVNode(MakeModelSearch)
                                ]))
                                : _createCommentVNode("", true),
                            (_unref(activeTab) === 1)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                    _createElementVNode("button", {
                                        type: "button",
                                        onClick: _cache[0] || (_cache[0] = ($event) => (_unref(setActiveTab)(2))),
                                        class: "oil-finder-panel__tab--text"
                                    }, [
                                        _createElementVNode("span", _hoisted_13, [
                                            _createElementVNode("img", {
                                                src: _unref(assetUrl)('/images/trade-site/search-thin.svg'),
                                                alt: "",
                                                class: "search-icon"
                                            }, null, 8, _hoisted_14)
                                        ]),
                                        _cache[2] || (_cache[2] = _createElementVNode("span", { class: "oil-finder-panel__tab--text__content" }, [
                                            _createElementVNode("span", { class: "oil-finder-panel__tab--text__question" }, "Don't know your registration?"),
                                            _createElementVNode("span", { class: "oil-finder-panel__tab--text__action" }, "Search by Make & Model")
                                        ], -1))
                                    ])
                                ]))
                                : _createCommentVNode("", true)
                        ])
                    ])
                ]),
                _createVNode(LicensePlateEditOverlay, {
                    ref_key: "editOverlay",
                    ref: editOverlay,
                    onVehicleSelected: handleVehicleSelected
                }, null, 512)
            ], 64));
        };
    }
});
